<template>
  <div class='h100-40 width-100vw h-scroll' :style="styleColorVar">
    <ejs-grid ref='grid' id='alarmPageId' height='calc(100% - 0px)' :dataSource='data' :contextMenuItems="contextMenuItems" :contextMenuOpen='menuBeforeOpenFunc' :contextMenuClick='menuClickFunc'
      :excelExportComplete='excelExportComplete' :selectionSettings='selectionOptions' :allowReordering='true' :allowResizing='true' :allowExcelExport='true' :actionComplete='actionComplete'>
      <e-columns>
        <e-column type='checkbox' textAlign='Center' minWidth='8' width='6%'></e-column>
        <e-column field='messageNo' :headerText='$t("Alarm.messageNo")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column field='alarmID' :headerText='$t("Alarm.alarmID")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column field='alarmName' :headerText='$t("Alarm.alarmName")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' width='10%'></e-column>
        <e-column field='levelStr' :headerText='$t("Alarm.alarmLevel")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' :disableHtmlEncode='false' :formatter='levelFormat' width='8%'></e-column>
        <e-column field='alarmTypeStr' :headerText='$t("Alarm.alarmType")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' :formatter='typeFormat' width='8%'></e-column>

        <!--
        <e-column field='neTypeStr' :headerText='$t("Alarm.neType")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='neName' :headerText='$t("Alarm.neName")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='equipmentType' :headerText='$t("Alarm.equipmentType")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        -->
        <e-column field='equipmentName' :headerText='$t("Alarm.equipmentName")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column field='neAlarmFDN' :headerText='$t("Alarm.neAlarmFDN")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column field='brdTypeStr' :headerText='$t("Alarm.brdType")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column field='appendInfo' :headerText='$t("Alarm.extraInfo")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10' width='8%'></e-column>
        <e-column field='xxdwinfo1' :headerText='$t("Alarm.xxdwinfo1")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10' width='8%'></e-column>
        <!-- <e-column field='deployIp_Id' :headerText='$t("Alarm.deployIpId")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='deployIp' :headerText='$t("Alarm.deployIp")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>-->

        <!-- <e-column field='envTypeName' :headerText='$t("Alarm.envType")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10'></e-column> -->
        <!-- <e-column field='envName' :headerText='$t("Alarm.envName")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10'></e-column> -->
        <!-- <e-column field='nodeTypeId' :headerText='$t("Alarm.isvirtual")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' :formatter='isVirtualFormat'></e-column> -->

        <e-column field='clearStateStr' :headerText='$t("Alarm.clearState")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' :formatter='clearFormat' width='8%'></e-column>
        <e-column field='clearType' :headerText='$t("Alarm.clearType")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' :formatter='clearTypeFormat' width='8%'></e-column>
        <e-column field='confirmStateStr' :headerText='$t("Alarm.confirmState")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' :formatter='confirmFormat' width='8%'></e-column>
        <e-column field='createTimeFormat' :headerText='$t("Alarm.createTime")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' width='11%'></e-column>
        <e-column field='clearTimeFormat' :headerText='$t("Alarm.clearTime")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' width='11%'></e-column>
        <e-column field='confirmTimeFormat' :headerText='$t("Alarm.confirmTime")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' width='11%'></e-column>
        <e-column field='clearUsrName' :headerText='$t("Alarm.clearUser")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column field='confirmUsrName' :headerText='$t("Alarm.confirmUser")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column field='xxdwinfo2' :headerText='$t("Alarm.xxdwinfo2")' :visible='false' textAlign='Center' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column field='xxkzinfo1' :headerText='$t("Alarm.xxkzinfo1")' :visible='false' textAlign='Center' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column field='xxkzinfo2' :headerText='$t("Alarm.xxkzinfo2")' :visible='false' textAlign='Center' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column field='xxkzinfo3' :headerText='$t("Alarm.xxkzinfo3")' :visible='false' textAlign='Center' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column field='xxkzinfo4' :headerText='$t("Alarm.xxkzinfo4")' :visible='false' textAlign='Center' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column field='cause' :headerText='$t("Alarm.cause")' :visible='false' textAlign='Center' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column field='advise' :headerText='$t("Alarm.advise")' :visible='false' textAlign='Center' clipMode='EllipsisWithTooltip' width='8%'></e-column>
        <e-column field='comment' :headerText='$t("Alarm.remark")' :visible='false' textAlign='Center' clipMode='EllipsisWithTooltip' width='8%'></e-column>
      </e-columns>
    </ejs-grid>
    <ejs-pager ref='pager' @click='getAlarmListData()' :currentPage='page.pageNo' :pageSize='page.pageSize' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager>
    <CustomDialog ref='detailDialog' :element='detailDialogSetting.element' :styles='detailDialogSetting.styles'>
      <template v-slot:dialog-content>
        <AlarmDetail ref='detailContent'></AlarmDetail>
      </template>
    </CustomDialog>
    <CustomDialog ref='filterDialog' :element='filterDialogSetting.element' :styles='filterDialogSetting.styles'>
      <template v-slot:dialog-content>
        <AlarmFilter url='/lte/ems/fm/alarmhistory/filter' ref='filterContent' :hasStatus='true'></AlarmFilter>
      </template>
    </CustomDialog>
  </div>
</template>
<script>
import { Reorder, Resize, ExcelExport, ContextMenu } from '@syncfusion/ej2-vue-grids';
import CustomDialog from '../../common/CustomDialog';
import AlarmDetail from '../historyAlarm/AlarmDetail';
import AlarmFilter from '../historyAlarm/AlarmFilter';
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'historyAlarmTable',
  components: {
    CustomDialog,
    AlarmDetail,
    AlarmFilter
  },
  props: {
    roleNe: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      styleColorVar:{},
      selectionOptions: { type: 'Multiple' },
      contextMenuItems: [
        // 历史告警不加确认和反确认
        // { text: `${this.$t('Alarm.acknowledge')}` },
        // { text: `${this.$t('Alarm.unconfirm')}` },
        { text: `${this.$t('Alarm.alarmDetails')}` }
      ],
      topoList: [],
      detailDialogSetting: {
        styles: {
          width: '810px',
          height: 'auto',
          model: true,
          visible: false
        },
        element: {
          title: this.$t('Alarm.alarmDetails'),
          target: '#app',
          refName: 'detail',
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide, buttonModel: { content: this.$t('Common.cancel') } },
            { click: this.saveDetails, buttonModel: { content: this.$t("Profile.confirm"), isPrimary: true } }
          ]
        }
      },
      filterDialogSetting: {
        styles: {
          width: '810px',
          height: 'auto',
          model: true,
          visible: false
        },
        element: {
          title: this.$t('Alarm.filterSetting'),
          refName: 'filter',
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide, buttonModel: { content: this.$t('Alarm.cancel') } },
            // { click: this.filterFilterFunc, buttonModel: { content: this.$t('Alarm.filter'), isPrimary: true } },
            { click: this.filterConfirmFunc, buttonModel: { content: this.$t('Alarm.confirm'), isPrimary: true } }
          ]
        }
      },
      page: {
        pageNo: 1,
        pageSize: 16,
        totalCount: 0,
        pageCount: 10
      },
      conditionsStatus: false,
      queryConditions: {
        systemId: '1',
        conditions: '', // 告警过滤时会有查询条件，筛调部分告警，初始化时需获取初始条件
        keywords: '', // 模糊查询关键字
      },
      data: []
    };
  },
  provide: {
    grid: [Reorder, Resize, ExcelExport, ContextMenu]
  },
  watch: {
    roleNe() {
      this.getAlarmListData();
      this.$parent.$parent.$refs.alarmCount.getAlarmCount();
    },
  },
  methods: {
    levelFormat(grids, data) {
      data.levelStr = this.$t(`Alarm.alarmLevel_${data.level}`);
      return `<span class='h-alarmLevel${data.level}'>${this.$t(`Alarm.alarmLevel_${data.level}`)}</span>`;
    },
    isVirtualFormat(grids, data){
      //现在36-48为5G网元，255 VDOS没有告警，不考虑
      if(data.nodeTypeId > 99){
        return this.$t(`Alarm.physics`);
      }else{
        return this.$t("Alarm.virtualNet");
      }
    },
    typeFormat(grids, data) {
      let str = this.$t(`Alarm.alarmType_${data.alarmType}`);
      data.alarmTypeStr = str;
      return str;
    },
    clearTypeFormat(grid, data){
      if(data.clearState==0){
        return '-';
      }else if(data.clearUsrName == 'System'){
        return this.$t(`Alarm.auto`);
      }else{
        return this.$t(`Alarm.manul`);
      }
    },
    clearFormat(grid, data) {
      let str = this.$t(`Alarm.alarmClearStatus_${data.clearState}`);
      data.clearStateStr = str;
      return str;
    },
    confirmFormat(grid, data) {
      let str = this.$t(`Alarm.alarmConfirmStatus_${data.confirmState}`);
      data.confirmStateStr = str;
      return str;
    },
    menuBeforeOpenFunc(menuArgs) { // 屏蔽表头的右键事件
      if ((!menuArgs.rowInfo.rowIndex && menuArgs.rowInfo.rowIndex !== 0) || (this.getCheckedData(true).length > 1)) {
        menuArgs.cancel = true;
      }
    },
    menuClickFunc(menuArgs) { // 为右键分配事件
      switch (menuArgs.element.innerText) {
        case `${this.$t('Alarm.confirm')}`:
          this.confirmAlarm();
          break;
        case `${this.$t('Alarm.unconfirm')}`:
          this.unconfirmAlarm();
          break;
        case `${this.$t('Alarm.alarmDetails')}`:
          this.showDetail();
          break;
        default:
      }
    },
    dialogHide() {
      this.$refs.detailDialog.clear();
      this.$refs.detailDialog.close();
      this.$refs.filterDialog.clear();
      this.$refs.filterDialog.close();
    },
    getColumnsMapper() {
      return `messageNo:${this.$t('Alarm.messageNo')};`
        + `alarmID:${this.$t('Alarm.alarmID')};`
        + `alarmName:${this.$t('Alarm.alarmName')};`
        + `levelStr:${this.$t('Alarm.alarmLevel')};`
        + `alarmTypeStr:${this.$t('Alarm.alarmType')};`
        + `neTypeStr:${this.$t('Alarm.neType')};`
        + `neName:${this.$t('Alarm.neName')};`
        + `neAlarmFDN:${this.$t('Alarm.neAlarmFDN')};`
        + `brdType:${this.$t('Alarm.brdType')};`
        + `clearStateStr:${this.$t('Alarm.clearState')};`
        + `confirmStateStr:${this.$t('Alarm.confirmState')};`
        + `createTimeFormat:${this.$t('Alarm.createTime')};`
        + `clearTimeFormat:${this.$t('Alarm.clearTime')};`
        + `confirmTimeFormat:${this.$t('Alarm.confirmTime')};`
        + `clearUsrName:${this.$t('Alarm.clearUser')};`
        + `confirmUsrName:${this.$t('Alarm.confirmUser')};`
        + `comment:${this.$t('Alarm.remark')};`
        + `xxdwinfo1:${this.$t('Alarm.xxdwinfo1')};`
        + `xxdwinfo2:${this.$t('Alarm.xxdwinfo2')};`
        + `xxkzinfo1:${this.$t('Alarm.xxkzinfo1')};`
        + `xxkzinfo2:${this.$t('Alarm.xxkzinfo2')};`
        + `xxkzinfo3:${this.$t('Alarm.xxkzinfo3')};`
        + `xxkzinfo4:${this.$t('Alarm.xxkzinfo4')};`
        + `cause:${this.$t('Alarm.cause')};`
        + `advise:${this.$t('Alarm.advise')};`;
    },
    getCheckedData(selectOnly) {
      // false: 不支持多选   true: 支持多选
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit('toast', {type: 'warning', content: `${this.$t('Alarm.no_checked')}`});
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit('toast', {type: 'warning', content: `${this.$t('Common.tips.onlyOneSelect')}`});
        return false;
      }
      return selectedRecords;
    },
    getCheckedVals() {
      const messageNos = [];
      const checkedData = this.getCheckedData(true);
      for (let i = 0; i < checkedData.length; i++) {
        messageNos.push(checkedData[i].messageNo);
      }
      return messageNos;
    },
    getAlarmListData(firstFlag) {
      // 获取表格数据
      const This = this;
      let conditionsStr = '';
      let keywordsStr = '';

      if (This.conditionsStatus === true) {
        conditionsStr = This.queryConditions.conditions;
      } else {
        keywordsStr = This.queryConditions.keywords;
      }
      This.page.pageNo = This.$refs.pager.ej2Instances.currentPage;
      if (This.page.pageNo == 1) {
        This.$refs.pager.ej2Instances.currentPage = 1;
      }
      if (firstFlag == true) {
        This.page.pageNo = 1;
        This.$refs.pager.ej2Instances.currentPage = 1;
      }
      this.$parent.$parent.$refs.alarmCount.getAlarmCount(This.queryConditions);
      // 触发
      this.$emit('paramChange', {
        conditions: conditionsStr,
        keywords: keywordsStr
      });
      let principal = sessionStorage.getItem('principal');
      let user = JSON.parse(principal);
      let userId = user.userId;

      EventBus.$emit('loading', { ison: true });
      This.$axios.post('/lte/ems/fm/alarmhistory/queryAlarm.html', {
        page: {
          pageNo: This.page.pageNo,
          pageSize: This.page.pageSize
        },
        keywords: keywordsStr,
        conditions: conditionsStr,
        roleNe: This.roleNe,
        userId:userId
      }).then((response) => {
        if (response && response.status === 200) {
          EventBus.$emit('loading', { ison: false });
          const result = response.data.resultVal;
          This.page.totalCount = result.totalCount;
          This.data = result.result;
        }
      });
    },
    exportAlarmListData() {
      // 导出选中表格数据
      const checkedData = this.getCheckedData(true);
      if (checkedData) {
        for (let i = 0; i < checkedData.length; i++) {
          //现在36-48为5G网元，255 VDOS没有告警，不考虑
          if(checkedData[i].nodeTypeId > 99){
            checkedData[i].nodeTypeId = this.$t(`Alarm.physics`);
          }else{
            checkedData[i].nodeTypeId = this.$t("Alarm.virtualNet");
          }
          //设置清除状态
          if(checkedData.clearState==0){
            checkedData[i].clearType = '-';
          }else if(checkedData.clearUsrName == 'System') {
            checkedData[i].clearType = this.$t(`Alarm.auto`);
          }else{
            checkedData[i].clearType = this.$t(`Alarm.manul`);
          }
        }
        const exportProperties = {
          fileName: `${this.$t('Alarm.historyAlarm')}.xlsx`,
          dataSource: checkedData
        };
        this.$refs.grid.getColumns()[0].visible = false;
        for (let i = 19; i < this.$refs.grid.getColumns().length; i++) {
          this.$refs.grid.getColumns()[i].visible = true;
        }
        this.$refs.grid.excelExport(exportProperties);
      }
    },
    exportAllAlarmListData() {
      console.log('export All history Alarm List Data');
      // 获取表格数据
      const This = this;
      let conditionsStr = '';
      let keywordsStr = '';

      if (This.conditionsStatus === true) {
        conditionsStr = This.queryConditions.conditions;
      } else {
        keywordsStr = This.queryConditions.keywords;
      }
      const principal = sessionStorage.getItem('principal');
      const user = JSON.parse(principal);

      const params = {
        conditions: conditionsStr,
        keywords: keywordsStr,
        roleNe: This.roleNe,
        userId: user.userId,
        exportType: {
          // xls,xlsx,csv
          exportFileType: 'xlsx',
        },
        fileParam: {
          fileName: `${this.$t('Alarm.historyAlarm')}`,
          header: [this.$t('Alarm.messageNo'), this.$t('Alarm.alarmID'), this.$t('Alarm.alarmName'), this.$t('Alarm.alarmLevel'), this.$t('Alarm.alarmType'), this.$t('Alarm.equipmentName'), this.$t('Alarm.neAlarmFDN'), this.$t('Alarm.brdType'), this.$t('Alarm.extraInfo'), this.$t('Alarm.xxdwinfo1'), this.$t('Alarm.clearState'), this.$t('Alarm.clearType'), this.$t('Alarm.confirmState'), this.$t('Alarm.createTime'), this.$t('Alarm.clearTime'), this.$t('Alarm.confirmTime'), this.$t('Alarm.clearUser'), this.$t('Alarm.confirmUser'), this.$t('Alarm.xxdwinfo2'), this.$t('Alarm.xxkzinfo1'), this.$t('Alarm.xxkzinfo2'), this.$t('Alarm.xxkzinfo3'), this.$t('Alarm.xxkzinfo4'), this.$t('Alarm.cause'), this.$t('Alarm.advise'), this.$t('Alarm.remark')],
          formatI18n: [this.$t('Alarm.alarmType_0'), this.$t('Alarm.alarmType_1'), this.$t('Alarm.alarmType_2'), this.$t('Alarm.alarmType_3'), this.$t('Alarm.alarmConfirmStatus_0'), this.$t('Alarm.alarmConfirmStatus_1'), this.$t('Alarm.alarmLevel_0'), this.$t('Alarm.alarmLevel_1'), this.$t('Alarm.alarmLevel_2'), this.$t('Alarm.alarmLevel_3'), this.$t('Alarm.alarmClearStatus_0'), this.$t('Alarm.alarmClearStatus_1'), this.$t('Alarm.auto'), this.$t('Alarm.manul')],
        },
      };
      console.log('params', params);
      const config = {
        responseType: 'blob',
        // 2023-8-8 韩洪波：设置该请求的超时时间为6分钟, 全局超时1分钟在axios.js中配置
        timeout: 6 * 60 * 1000
      };
      // EventBus.$emit('loading', { ison: true });
      this.$loading.showLoadding(this.$t('DeployManagement.exporting'));
      this.$axios.post('/lte/ems/fm/alarmhistory/exportAllData', params, config).then((res) => {
        // 判断是否错误
        const reader = new FileReader(); // 创建读取文件对象
        reader.readAsText(res.data, 'utf-8'); // 设置读取的数据以及返回的数据类型为utf-8
        // eslint-disable-next-line func-names
        reader.addEventListener('loadend', () => {
          this.$loading.hideLoadding();
          // EventBus.$emit('loading', { ison: false });
          if (reader.result.indexOf('{') === 0) {
            const resJson = JSON.parse(reader.result);
            if (resJson.errorCode === '1117') {
              // 超过最大同时导出数量
              EventBus.$emit('toast', { type: 'warning', content: This.$t('Alarm.moreThanMaxConcurrentExportNum') });
            } else if (resJson.errorCode === '1119') {
              // 超过最大导出明细数量
              EventBus.$emit('toast', { type: 'warning', content: This.$t('Alarm.moreThanMaxExportDetailNum') });
            } else if (resJson.errorCode === '1120') {
              // 查询结果数量为0
              EventBus.$emit('toast', { type: 'warning', content: This.$t('Alarm.resultCountIsZero') });
            } else {
              EventBus.$emit('toast', { type: 'warning', content: This.$t('Pm.unknownError') });
              console.log('reader.result:', reader.result);
            }
            return;
          }
          const link = document.createElement('a');
          const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          const dateStr = new Date().Format('yyyyMMddHHmmss');
          link.setAttribute('download', `${This.$t('Alarm.historyAlarm') + dateStr}.xlsx`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
      });
    },
    excelExportComplete() {
      this.$refs.grid.getColumns()[0].visible = true;
      for (let i = 19; i < this.$refs.grid.getColumns().length; i++) {
        this.$refs.grid.getColumns()[i].visible = false;
      }
    },
    confirmAlarm() {
      // 告警确认
      const This = this;
      const checkedData = This.getCheckedData(true);
      if (checkedData) {
        This.$axios.post('/lte/ems/fm/alarmhistory/confirm', This.getCheckedVals()).then((response) => {
          if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
            This.clearOrConfirmMessage = `${this.$t('Alarm.success')} ${response.data.resultVal.message}`;
            EventBus.$emit('toast', {type: 'success', content: This.clearOrConfirmMessage});
            This.page.pageNo = 1;
            This.getAlarmListData(true);
          }
        });
      }
    },
    unconfirmAlarm() {
      // 告警反确认
      let username = '';
      let principal = sessionStorage.getItem('principal');
      if (!!principal) {
        let user = JSON.parse(principal);
        username = user.username;
      }
      const This = this;
      const checkedData = This.getCheckedData(true);
      
      if(checkedData[0].confirmState == 0){
        EventBus.$emit('toast', {type: 'warning', content: This.$t('Alarm.unconfirm_unconfirm')});
        return ;
      }
      if(username == 'Eadmin' || checkedData[0].confirmUsrName == username || username == 'unmadmin'){
        This.$axios.post('/lte/ems/fm/alarmhistory/unconfirm', This.getCheckedVals()).then((response) => {
          if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
            This.clearOrConfirmMessage = `${this.$t('Alarm.success')} ${response.data.resultVal.message}`;
            EventBus.$emit('toast', {type: 'success', content: This.clearOrConfirmMessage});
            This.page.pageNo = 1;
            This.getAlarmListData(true);
          }
        });
        return ;
      }
      EventBus.$emit('toast', {type: 'warning', content: This.$t('Alarm.noPermission')});

    },
    showDetail() {
      // 告警详情
      const checkedData = this.getCheckedData(false);
      if (checkedData) {
        this.$refs.detailDialog.show();
        this.$refs.detailContent.setAlarmId(checkedData[0]);
      }
    },
    filterFunc() {
      // 告警过滤
      this.$refs.filterDialog.show();
      this.$refs.filterContent.setTopoList(this.topoList);
      this.$refs.filterContent.setConditions(this.queryConditions.conditions);
    },
    filterConfirmFunc(clickEvent) {
      if (clickEvent.keyCode === 13) {
        return;
      }
      // 告警过滤确认事件
      this.queryConditions.conditions = this.$refs.filterContent.getConditions();
      const conditions = JSON.parse(this.queryConditions.conditions);
      conditions.flag = true;
      this.queryConditions.conditions = JSON.stringify(conditions);
      this.topoList = this.$refs.filterContent.getTopoList();
      this.dialogHide();
      this.conditionsStatus = true;
      this.getAlarmListData(true);
    },
     // 告警显示过滤
     filterFilterFunc(clickEvent) {
      if (clickEvent.keyCode === 13) {
        return;
      }
      this.queryConditions.conditions = this.$refs.filterContent.getConditions();
      const conditions = JSON.parse(this.queryConditions.conditions);
      conditions.flag = false;
      this.queryConditions.conditions = JSON.stringify(conditions);
      this.topoList = this.$refs.filterContent.getTopoList();
      this.dialogHide();
      this.conditionsStatus = true;
      this.getAlarmListData(true);
    },
    actionComplete() {
      this.$refs.grid.selectRow(0, true);
      this.$refs.grid.selectRow(0, true);
    },
    saveDetails(){
      const detail = this.$refs.detailContent.getAlarmDetails();
      this.$axios.post('/lte/ems/fm/alarmhistory/changeDetails', detail).then((response) => {
          if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
            EventBus.$emit('toast', {type: 'success', content: this.$t('Common.tips.success')});
            this.dialogHide();
            this.getAlarmListData(true);

          }
        });
    }
  },
  mounted(){
    this.styleColorVar = JSON.parse(localStorage.getItem('styleColorVar'));
  }
};
</script>
